var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-body-user-info" }, [
    _c("div", { staticClass: "description" }, [
      _vm._v("\n    Add a new client by entering the information below.\n  ")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "email" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Client name:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.clientInfo.clientName,
              expression: "clientInfo.clientName"
            }
          ],
          staticClass: "input",
          attrs: { type: "text", placeholder: "Client name" },
          domProps: { value: _vm.clientInfo.clientName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.clientInfo, "clientName", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "name row" }, [
      _c("div", { staticClass: "first-name" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v("Client contact first name:")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.clientInfo.firstName,
                expression: "clientInfo.firstName"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", placeholder: "First Name" },
            domProps: { value: _vm.clientInfo.firstName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.clientInfo, "firstName", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "last-name" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v("Client contact last name:")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.clientInfo.lastName,
                expression: "clientInfo.lastName"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", placeholder: "Last Name" },
            domProps: { value: _vm.clientInfo.lastName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.clientInfo, "lastName", $event.target.value)
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "email" }, [
      _c("div", { staticClass: "text" }, [
        _vm._v("Client contact's email address:")
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.clientInfo.email,
              expression: "clientInfo.email"
            }
          ],
          staticClass: "input",
          attrs: { type: "text", placeholder: "E.g. hannah_welch@gmail.com" },
          domProps: { value: _vm.clientInfo.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.clientInfo, "email", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      !_vm.isEmail()
        ? _c("div", { staticClass: "errorBackground" }, [
            _c("span", { staticClass: "errorDetail" }, [
              _vm._v("Invalid email format.")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9ba04e66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ba04e66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/AddClientModal.vue
// module id = 1289
// module chunks = 1